module.exports = __webpack_public_path__ + "img/Tessellate54.21c94835.jpg";